import axios from "../axiosInstance";
import { CompleteFreeMembershipResponse } from "./types";

// Finalizes a $0 membership without going through Stripe. The backend records
// the membership the same way the post-payment handler does for paid orders,
// minus the payment intent.
export const completeFreeMembership = async (
  uuid: string,
): Promise<CompleteFreeMembershipResponse> => {
  const response = await axios.post<CompleteFreeMembershipResponse>(
    `/api/public/join-session/${uuid}/complete-free-membership`,
  );
  return response.data;
};
